<template>
  <span @click="$refs.input.click()" :class="['radio-button-wrapper', { 'disabled': disabled }]">
    <input
      type="radio"
      ref="input"
      :value="value"
      :checked="checked"
      @change="$emit('change', value)"
    />
    <span class="radio-button"></span>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'ProaRadioButton',
  props: {
    value: [String, Number],
    checked: Boolean,
    disabled: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.radio-button-wrapper {
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
}

input[type="radio"] {
  display: none;
}

.radio-button {
  box-sizing: border-box;
  display: inline-block;
  padding: 5px 15px;
  position: relative;
  width: auto;
}
.radio-button::before {
  content: '';
  display: block;
  height: 16px;
  left: 5px;
  margin-top: -8px;
  position: absolute;
  top: 50%;
  width: 16px;
  border: 2px solid $dark-border-color;
  border-radius: 50%;
  background-color: white;
}
.radio-button::after {
  content: '';
  border-right: 2.5px solid white;
  border-bottom: 2.5px solid white;
  display: block;
  height: 10px;
  width: 6px;
  left: 10px;
  margin-top: -6px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
}

input[type=radio]:checked + .radio-button::before {
  border: none;
  background-color: $secondary-color;
}

input[type=radio]:checked + .radio-button::after {
  opacity: 1;
}

</style>
